import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useLazyQuery } from '@apollo/client'

// import { Form } from 'informed'
// import { Col, Row } from 'react-flexbox-grid'
import { useParams } from 'react-router-dom'

// import * as moment from 'moment'

// import Divider from 'components/Divider'
import DataTable from 'components//DataTableTest'
// import { DateTimePicker, Checkbox } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
// import Button from 'components/Button'
// import { DataTable } from 'components//DataTable'

import { listDeliveryNotes } from '../gql'
import DatePeriod from '../modals/shared/DatePeriod'

import { deliveryNotes } from '../tableColumns'

const DeliveryNotes = () => {
	const [t] = useTranslation()
	const { id } = useParams()
	const [showDeleted, setShowDeleted] = useState(false)

	// from: '2009-10-01T00:00:00.000Z', to: '2009-11-01T00:00:00.000Z', clientId: 144
	/* const dateInterval = {
		to: moment(new Date()).utc().endOf('day').toISOString(),
		from: moment(new Date()).utc().startOf('day').toISOString()
	} */

	const [getData, { data }] = useLazyQuery(listDeliveryNotes)

	let items = []
	if (data?.cashAssist?.listDeliveryNotes?.items) {
		let tableData = []
		if (showDeleted) {
			tableData = data.cashAssist.listDeliveryNotes.items
		} else {
			tableData = data.cashAssist.listDeliveryNotes.items.filter(element => element.isDeleted === false)
		}
		items = tableData
	}

	const requestData = ({ value }) => {
		setShowDeleted(value.showDeleted)
		getData({ variables: { id, dateInterval: value.date } })
	}

	/* const requestData = (formData) => {
		if (formData?.dateInterval) {
			getData({ variables: { id, dateInterval: formData.dateInterval } })
		}
	} */

	return (
		<Fragment>
			<ContentBlock>
				{/* <Form
					onSubmit={(values) => requestData(values)}
					initialValues={{ dateInterval }}
					render={({ formState }) => (
						<Fragment>
							<Row>
								<Col xs>
									<DateTimePicker
										picker='date'
										label={{ from: t('common.fields.from_date'), to: t('common.fields.to_date') }}
										field='dateInterval'
										interval/>
									<Checkbox
										field='showDeleted'
										fieldState={{ value: showDeleted }}
										onChange={(event)=>setShowDeleted(event.target.checked)}
										label={t('credit_client_section.strings.show_deleted')}
										inline/>
								</Col>
							</Row>
							<Divider height={20}/>
							<Row>
								<Col xs>
									<Button type='submit' status='primary' text={t('common.buttons.calculate')}/>
								</Col>
							</Row>
						</Fragment>
					)}/> */}
				<DatePeriod onChange={value => requestData({ value })} showDeletedRecords/>
			</ContentBlock>
			<ContentBlock>
				<DataTable
					data={items}
					columns={deliveryNotes(t)}
					withSearch
				/>
			</ContentBlock>
		</Fragment>
	)
}

export default DeliveryNotes
